export default "__VITE_ASSET__CRLtAQs7__"